import { render, staticRenderFns } from "./IP_DxSummary.vue?vue&type=template&id=2b0c7420&"
import script from "./IP_DxSummary.vue?vue&type=script&lang=js&"
export * from "./IP_DxSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports